import events from 'events.js';
import bsn from 'libraries/bootstrap-native.js';

function preventHide(event) {
    event.stopPropagation();
}

(async function () {
    await events.ready();

    for (const elem of Array.from(document.getElementsByClassName('adslot'))) {
        if (!window.googletag) {
            window.googletag = {};
            window.googletag.cmd = [];
            const scriptElWithNonce = document.querySelector('[nonce]');
            const gads = document.createElement('script');
            gads.src = '//www.googletagservices.com/tag/js/gpt.js';
            gads.setAttribute(
                'nonce',
                scriptElWithNonce.nonce ||
                    scriptElWithNonce.getAttribute('nonce'),
            );
            const node = document.getElementsByTagName('script')[0];
            node.parentNode.insertBefore(gads, node);
        }
        const googletag = window.googletag;
        googletag.cmd.push(function () {
            const size = JSON.parse(elem.dataset.size);
            const mapping = googletag
                .sizeMapping()
                .addSize([0, 0], size.mobile)
                .addSize([320, 320], size.tablet)
                .addSize([1050, 200], size.desktop)
                .build();
            const slot = googletag
                .defineSlot(
                    `/${elem.dataset.networkCode}/${elem.dataset.adunit}`,
                    [size.mobile, size.tablet, size.desktop],
                    elem.id,
                )
                .defineSizeMapping(mapping)
                .addService(googletag.pubads().setForceSafeFrame(true))
                .setCollapseEmptyDiv(true, true);

            const stringKwargs = JSON.parse(elem.dataset.stringKwargs);
            const listKwargs = JSON.parse(elem.dataset.listKwargs);
            for (const arr of [stringKwargs, listKwargs]) {
                for (const key in arr) {
                    let value;
                    try {
                        value = JSON.parse(arr[key]);
                    } catch (e) {
                        value = arr[key];
                    }
                    slot.setTargeting(key, value);
                }
            }
        });
        const openDuration = 5000;
        const adPopover = elem.parentNode.querySelector(
            '[data-toggle="ad-popover"]',
        );
        const popover = new bsn.Popover(adPopover, {
            placement: 'bottom',
            template: `<div role="tooltip" class="popover">
                <div class="arrow"></div>
                <div class="popover-content">${adPopover.dataset.content}</div>
                <div class="popover-content">${adPopover.dataset.link}</div>
                </div>`,
            delay: openDuration,
        });
        function hidePopover() {
            popover.delay = 0;
            popover.hide();
        }
        events.listen(adPopover, 'shown.bs.popover', function () {
            const popoverEl = document.getElementsByClassName('popover')[0];
            events.listen(popoverEl, 'click', preventHide);
            events.listen(document.body, 'click', hidePopover);
        });
        events.listen(adPopover, 'hide.bs.popover', function () {
            const popoverEl = document.getElementsByClassName('popover')[0];
            events.unlisten(popoverEl, 'click', preventHide);
            events.unlisten(document.body, 'click', hidePopover);
            popover.delay = openDuration;
        });
    }

    const googletag = window.googletag;
    if (googletag) {
        googletag.cmd.push(function () {
            googletag.pubads().enableSingleRequest();
            googletag.pubads().setForceSafeFrame(true);

            googletag
                .pubads()
                .addEventListener('slotRenderEnded', function (event) {
                    const container = document.getElementById(
                        event.slot.getSlotElementId(),
                    ).parentNode;
                    if (event.isEmpty) {
                        container.classList.add('hidden');
                    } else {
                        container.classList.remove('hidden');
                        container.removeAttribute('hidden');
                    }
                });
            googletag.enableServices();
            const elems = Array.from(
                document.getElementsByClassName('adslot'),
            );
            for (const elem of elems) {
                googletag.display(elem.id);
            }
        });
    }
})();
